var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _vm.inMessage
        ? _c(
            "span",
            [
              _vm.action == "add"
                ? _c(
                    "b-dropdown-item",
                    {
                      staticClass: "no-border",
                      attrs: { size: _vm.size, title: _vm.$t("ASSIGN") },
                      on: { click: _vm.openAssign },
                    },
                    [_vm._v(_vm._s(_vm.$t("ASSIGN")))]
                  )
                : _vm._e(),
              _vm.action == "clear"
                ? _c(
                    "b-dropdown-item",
                    {
                      staticClass: "no-border",
                      attrs: { size: _vm.size, title: _vm.$t("UNASSIGN") },
                      on: { click: _vm.clearBtn },
                    },
                    [_vm._v(_vm._s(_vm.$t("UNASSIGN")))]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      !_vm.inMessage
        ? _c(
            "span",
            [
              _vm.action == "add"
                ? _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: {
                        variant: "primary",
                        size: _vm.size,
                        title: _vm.$t("ASSIGN"),
                      },
                      on: { click: _vm.openAssign },
                    },
                    [_vm._v(_vm._s(_vm.$t("ASSIGN")))]
                  )
                : _vm._e(),
              _vm.action == "clear"
                ? _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: {
                        variant: "secondary",
                        size: _vm.size,
                        title: _vm.$t("UNASSIGN"),
                      },
                      on: { click: _vm.clearBtn },
                    },
                    [_vm._v(_vm._s(_vm.$t("UNASSIGN")))]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            id: "functionbox-assign-user",
            size: "lg",
            "hide-header": "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            visible: "",
            "ok-only": "",
            "dialog-class": _vm.teams.theme,
            centered: "",
            "ok-title": _vm.$t("CANCEL"),
          },
          on: { ok: _vm.cancelBtn },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "b-form",
            { staticClass: "mt-2", attrs: { inline: "" } },
            [
              _c("b-form-input", {
                staticClass: "searchText newline-mobile ml-0",
                attrs: { trim: "", placeholder: _vm.$t("SEARCH") },
                on: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    $event.preventDefault()
                  },
                },
                model: {
                  value: _vm.searchText,
                  callback: function ($$v) {
                    _vm.searchText = $$v
                  },
                  expression: "searchText",
                },
              }),
            ],
            1
          ),
          _c("b-table", {
            staticClass: "mt-2",
            attrs: {
              small: "",
              busy: _vm.loading,
              bordered: "",
              items: _vm.items,
              hover: "",
              fields: _vm.fields,
            },
            on: { "row-clicked": _vm.clickedRow },
            scopedSlots: _vm._u([
              {
                key: "cell(name)",
                fn: function (data) {
                  return [
                    _c(
                      "b-form",
                      { attrs: { inline: "" } },
                      [
                        _c("b-img", {
                          staticClass: "profileImage",
                          attrs: {
                            src: "/img/default-avatar.png",
                            alt: "placeholder",
                            rounded: "circle",
                          },
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(data.item.name) +
                            "\n            "
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "cell(email)",
                fn: function (data) {
                  return [_vm._v(_vm._s(data.item.email))]
                },
              },
              {
                key: "cell(id)",
                fn: function (data) {
                  return [
                    _c(
                      "b-form",
                      { attrs: { inline: "" } },
                      [
                        _c("UserInfo", {
                          attrs: {
                            image: "/img/default-avatar.png",
                            primary: data.item.name,
                            secondary: data.item.email,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "table-busy",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "text-center my-2" },
                      [_c("b-spinner", { staticClass: "align-middle" })],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("b-pagination", {
            staticClass: "mt-2",
            attrs: {
              "total-rows": _vm.totalItems,
              "per-page": _vm.limit,
              align: "center",
              pills: "",
            },
            on: { input: _vm.getCurrentUsers },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }